import './js/api/fetchAPI';
import './js/dom/dom';
import './js/utils/utils';
